import React, {useState} from 'react';
import {Col, Menu} from "antd";
import {NavLink} from "react-router-dom";

export default function MainMenu() {

    const [menuItemIndex, setMenuItemIndex] = useState('0');

    return (
        <Col span={12}>
            <Menu theme="light" defaultSelectedKeys={['0']} style={{border: 'none'}} mode="horizontal" selectedKeys={[menuItemIndex]}>
                <Menu.Item key={0}>
                    <NavLink onClick={() => setMenuItemIndex('0')} to="/">HOME</NavLink>
                </Menu.Item>
                <Menu.Item key={1}>
                    <NavLink onClick={() => setMenuItemIndex('1')} to="/about">ABOUT</NavLink>
                </Menu.Item>
                <Menu.Item key={2}>
                    <NavLink onClick={() => setMenuItemIndex('2')} to="/example">EXAMPLES</NavLink>
                </Menu.Item>
                <Menu.Item key={3}>
                    <NavLink onClick={() => setMenuItemIndex('3')} to="/help">HELP</NavLink>
                </Menu.Item>
                <Menu.Item key={4}>
                    <NavLink onClick={() => setMenuItemIndex('4')} to="/references">REFERENCES</NavLink>
                </Menu.Item>
            </Menu>
        </Col>
    )
}